import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import DataTableLayout from "layouts/DatatableLayout";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
import { Box, Paper, Typography, MenuItem, Divider, Stack } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
import Select from "react-select";
// redux
import { getReportSaleVisitAndReserve } from "../../redux/handlers/report/getReportSaleVisitAndReserve.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
export function ReportSaleVisitAndReserve() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), selectedMonth = _useState[0], setSelectedMonth = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), dataChart = _useState1[0], setDataChart = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), saleId = _useState2[0], setSaleId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), saleName = _useState3[0], setSaleName = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionSale = _useState4[0], setOptionSale = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), datalist = _useState5[0], setDatalist = _useState5[1];
    // Reducer
    var getReportSaleVisitAndReserveReducer = useAppSelector(function(state) {
        return state.getReportSaleVisitAndReserveReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var formatChangePercent = function(value) {
        var percent = Number(value) || 0;
        if (percent > 0) {
            return "+".concat(percent, "%");
        }
        return "".concat(percent, "%");
    };
    // Load data
    useEffect(function() {
        var payload = {};
        if (selectedMonth) {
            payload.month = moment(selectedMonth).format("YYYY-MM");
        }
        if (saleId) {
            payload.saleid = parseInt(saleId);
        }
        dispatch(getReportSaleVisitAndReserve(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        selectedMonth,
        saleId
    ]);
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getReportSaleVisitAndReserveReducer.isFetching);
        if (getReportSaleVisitAndReserveReducer.data) {
            var _getReportSaleVisitAndReserveReducer_data;
            // setDataChart(getReportSaleVisitAndReserveReducer?.data?.data);
            setDatalist(getReportSaleVisitAndReserveReducer === null || getReportSaleVisitAndReserveReducer === void 0 ? void 0 : (_getReportSaleVisitAndReserveReducer_data = getReportSaleVisitAndReserveReducer.data) === null || _getReportSaleVisitAndReserveReducer_data === void 0 ? void 0 : _getReportSaleVisitAndReserveReducer_data.data);
        }
    }, [
        getReportSaleVisitAndReserveReducer
    ]);
    useEffect(function() {
        setIsLoading(allSetUserReducer.isFetching);
        if (allSetUserReducer.data) {
            var data = allSetUserReducer.data.data.filter(function(v) {
                return v.sys_user_role_id == 3;
            });
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var arr = Array.from(new Map(data.map(function(ele) {
                return [
                    ele === null || ele === void 0 ? void 0 : ele.sys_user_id,
                    {
                        value: ele === null || ele === void 0 ? void 0 : ele.sys_user_id,
                        label: ele === null || ele === void 0 ? void 0 : ele.sys_user_fullname
                    }
                ];
            })).values());
            setOptionSale(_to_consumable_array(all).concat(_to_consumable_array(arr)));
        }
    }, [
        allSetUserReducer
    ]);
    var columns = [
        {
            name: "เดือน",
            selector: function(row) {
                return moment(row === null || row === void 0 ? void 0 : row.month).locale("th").format("MMMM YYYY");
            }
        },
        {
            name: "เซลล์",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.sale_name;
            }
        },
        {
            name: "จำนวนใบจอง",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.reserve_count;
            },
            right: "true"
        },
        {
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.reserve_change_percent;
            },
            name: "จำนวน% เพิ่ม/ลด (ใบจอง)",
            right: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: Number(row === null || row === void 0 ? void 0 : row.reserve_change_percent) < 0 ? "#dc3545" : "#198754",
                        fontWeight: 600
                    },
                    children: formatChangePercent(row === null || row === void 0 ? void 0 : row.reserve_change_percent)
                });
            }
        },
        {
            name: "จำนวนใบเยี่ยมชม",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.visit_count;
            },
            right: "true"
        },
        {
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.visit_change_percent;
            },
            name: "จำนวน% เพิ่ม/ลด (ใบเยี่ยมชม)",
            right: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: Number(row === null || row === void 0 ? void 0 : row.visit_change_percent) < 0 ? "#dc3545" : "#198754",
                        fontWeight: 600
                    },
                    children: formatChangePercent(row === null || row === void 0 ? void 0 : row.visit_change_percent)
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            p: 3
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานเปรียบเทียบใบเยี่ยมชมกับใบจอง"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานเปรียบเทียบใบเยี่ยมชมกับใบจอง"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3",
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        className: "w-100 select-st-3 me-3",
                                        placeholder: "ค้นหาเซลล์ที่ดูแล",
                                        options: optionSale,
                                        value: optionSale.find(function(opt) {
                                            return opt.value === saleId;
                                        }) || "",
                                        onChange: function(e) {
                                            setSaleId(e ? e.value : "");
                                            setSaleName(e ? e.label : "");
                                        },
                                        isClearable: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3",
                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                        selected: selectedMonth,
                                        onChange: function(date) {
                                            return setSelectedMonth(date);
                                        },
                                        dateFormat: "MM/yyyy",
                                        showMonthYearPicker: true,
                                        className: "form-control w-100",
                                        placeholderText: "เลือกเดือน",
                                        customInput: /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                position: "relative"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    children: selectedMonth ? moment(selectedMonth).format("MM/YYYY") : /*#__PURE__*/ _jsx("span", {
                                                        className: "!text-[#8a898a]",
                                                        children: "เลือกเดือน"
                                                    })
                                                }),
                                                selectedMonth && /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setSelectedMonth(null);
                                                    },
                                                    style: {
                                                        position: "absolute",
                                                        right: "8px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        border: "none",
                                                        background: "transparent",
                                                        cursor: "pointer",
                                                        fontSize: "16px",
                                                        lineHeight: 1
                                                    },
                                                    children: "✕"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-0 py-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    });
}
